import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalLoginComponent } from 'src/app/components/modals/modal-login/modal-login.component';

@Component({
  standalone: false,
  selector: 'app-edit-report',
  templateUrl: './edit-admin-field.component.html',
  styleUrls: ['./edit-admin-field.component.scss']
})
export class EditAdminFieldComponent implements OnInit {
  @Input() fields: Array<string>;
  form: UntypedFormGroup
  formSubmitted = false;
  formFields = [];
  emailModel = '';
  element: any;

  constructor(
    public dialogRef: MatDialogRef<ModalLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: UntypedFormBuilder,
  ) { }

  ngOnInit() {
    this.element = this.data.element || {};
    this.formFields = Object.keys(this.data.formFields);
    this.form = this.buildForm(this.formFields);
  }

  cancel() {
    this.dialogRef.close('');
  }

  submitForm() {
    this.formSubmitted = true;
    if (this.form.valid ) {
      this.dialogRef.close(this.form.value);
    }
  }

  private buildForm(fields: Array<string>) {
    const group = new UntypedFormGroup({}) //<---create a formGroup empty
    fields.forEach(field=>{
        group.addControl(field ,new UntypedFormControl(this.element[field] || this.data.formFields[field].value, Validators.required))
    })
    return group;
  }

}
